function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import PropTypes from 'prop-types';
import { Form, Table, Button } from 'mkui-fd';
import { getUUID } from './util';
import { debounce } from 'lodash';
import { initColumns, bindingFieldValue, initDataSource, getValidateResult, bindingRecord } from './service';

var EditTable = /*#__PURE__*/function (_React$Component) {
  _inherits(EditTable, _React$Component);

  function EditTable(props) {
    var _this;

    _classCallCheck(this, EditTable);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(EditTable).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "deleteRecordHandle", function (uuid) {
      var dataSource = _this.state.dataSource;
      var dlt = dataSource.findIndex(function (ds) {
        return ds.uuid === uuid;
      });

      var newDataSource = _toConsumableArray(dataSource);

      newDataSource.splice(dlt, 1); // 排序

      newDataSource.forEach(function (value, index) {
        value.index = index + 1;
      });

      _this.setState(function () {
        return {
          dataSource: newDataSource
        };
      }, function () {
        _this.props.form.setFieldsValue({
          uuids: _toConsumableArray(_this.state.dataSource.map(function (ds) {
            return ds.uuid;
          }))
        });
      });
    });

    _defineProperty(_assertThisInitialized(_this), "copyRecordHandle", function (uuid) {
      var newUuid = getUUID(); // this.setDataSource(newUuid)

      _this.setState(function (state) {
        return {
          dataSource: [].concat(_toConsumableArray(state.dataSource), [{
            uuid: newUuid,
            index: state.dataSource.length + 1
          }])
        };
      }, function () {
        _this.props.form.setFieldsValue({
          uuids: _toConsumableArray(_this.state.dataSource.map(function (ds) {
            return ds.uuid;
          }))
        });

        bindingRecord(_this.props.form, uuid, newUuid);
      });
    });

    _defineProperty(_assertThisInitialized(_this), "addRecordHandle", function () {
      // 新增时校验数据
      var newUuid = getUUID();

      _this.setDataSource(newUuid);
    });

    _defineProperty(_assertThisInitialized(_this), "setDataSource", function (uuid) {
      _this.setState(function (state) {
        return {
          dataSource: [].concat(_toConsumableArray(state.dataSource), [{
            uuid: uuid,
            index: state.dataSource.length + 1
          }])
        };
      }, function () {
        _this.props.form.setFieldsValue({
          uuids: _toConsumableArray(_this.state.dataSource.map(function (ds) {
            return ds.uuid;
          }))
        });
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onValidate", function () {
      var disabled = _this.props.disabled;

      if (disabled) {
        return true;
      }

      _this.props.form.validateFields();

      var errors = _this.props.form.getFieldsError();

      return getValidateResult(errors);
    });

    _defineProperty(_assertThisInitialized(_this), "renderEmpty", function () {
      var dataSource = _this.state.dataSource;
      var _this$props = _this.props,
          prefixCls = _this$props.prefixCls,
          disabled = _this$props.disabled,
          addBtnText = _this$props.addBtnText;

      if (dataSource.length > 0) {
        return null;
      }

      return React.createElement("div", {
        className: "".concat(prefixCls, "-empty")
      }, React.createElement(Button, {
        type: "dashed",
        className: "".concat(prefixCls, "-empty-button"),
        disabled: disabled,
        onClick: _this.addRecordHandle
      }, addBtnText));
    });

    var defaultValue = props.defaultValue,
        leastOneRecord = props.leastOneRecord;
    _this.state = {
      dataSource: initDataSource(defaultValue, leastOneRecord)
    };
    _this.columns = initColumns(props, _this.deleteRecordHandle, _this.copyRecordHandle);
    return _this;
  }

  _createClass(EditTable, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props2 = this.props,
          form = _this$props2.form,
          config = _this$props2.config,
          setComponentValue = _this$props2.setComponentValue;
      var dataSource = this.state.dataSource;
      bindingFieldValue(config, form, dataSource, setComponentValue);
      var getFieldDecorator = form.getFieldDecorator;
      getFieldDecorator('uuids', {
        initialValue: _toConsumableArray(dataSource.map(function (ds) {
          return ds.uuid;
        }))
      });
    } // 删除

  }, {
    key: "render",
    value: function render() {
      var dataSource = this.state.dataSource;
      var _this$props3 = this.props,
          prefixCls = _this$props3.prefixCls,
          titleText = _this$props3.titleText,
          addBtnText = _this$props3.addBtnText,
          disabled = _this$props3.disabled;
      return React.createElement("div", {
        className: prefixCls
      }, React.createElement("div", {
        className: "".concat(prefixCls, "-title")
      }, React.createElement("div", {
        className: "".concat(prefixCls, "-title-name")
      }, titleText), React.createElement(Button, {
        className: "".concat(prefixCls, "-title-add"),
        onClick: this.addRecordHandle,
        disabled: disabled
      }, addBtnText)), React.createElement(Form, null, React.createElement(Table, {
        tableLayout: "auto",
        className: "".concat(prefixCls, "-table"),
        pagination: false,
        dataSource: dataSource,
        columns: this.columns,
        scroll: {
          x: this.columns.length * 150
        },
        rowKey: "uuid"
      }), this.renderEmpty()));
    }
  }]);

  return EditTable;
}(React.Component);

EditTable.propTypes = {
  prefixCls: PropTypes.string,
  titleText: PropTypes.string,
  addBtnText: PropTypes.string,
  form: PropTypes.object,
  config: PropTypes.object,
  defaultValue: PropTypes.array,
  disabled: PropTypes.bool,
  leastOneRecord: PropTypes,
  setComponentProps: PropTypes.func,
  setComponentValue: PropTypes.func,
  setComponentRules: PropTypes.func
};
EditTable.defaultProps = {
  prefixCls: 'mkui-edit-table',
  titleText: '明细',
  addBtnText: '添加明细',
  disabled: false,
  leastOneRecord: false,
  defaultValue: [],
  setComponentProps: function setComponentProps() {},
  setComponentValue: function setComponentValue(config, value) {
    return value;
  },
  setComponentRules: function setComponentRules() {
    return [];
  }
};
export default Form.create({
  onValuesChange: debounce(function (props, changedValues, allValues) {
    var onChange = props.onChange,
        _props$config$propert = props.config.property.detailTableFields,
        detailTableFields = _props$config$propert === void 0 ? [] : _props$config$propert;

    if (onChange) {
      onChange(allValues, detailTableFields);
    }
  }, 500)
})(EditTable);
//# sourceMappingURL=EditTable.js.map
